module.exports = __webpack_public_path__ + "img/Door_Closed.38be2f57.jpg";